<div>
    <v-dialog :persistent='true' class="dialog-class" v-model="verfiyAnonymousUserDialog" width="500">
        <v-card>
            <div class="p-3">
                <div>
                    <div class="row">
                        <h5 class="col-12">
                            <b> {{$t('anonymousUserVerification.dialogs.verfiyAnonymousUserDialog')}} </b>
                        </h5>
                        <div class="col-12 text-center text-primary px-50 px-sm-0">
                            <h5 class="procurationForm__fieldLabel Required "
                                style="line-height: normal; font-size: 1rem;">
                                {{$t('anonymousUserVerification.dialogs.otpPlaceHolder')}}
                            </h5>
                            <div dir="ltr" class="d-flex justify-content-center">
                                <div dir="ltr" class="col-md-8 col-sm-8">
                                    <v-otp-input :disabled="!showVerfyButton" autofocus ref="otpinput" dir="ltr"
                                        @finish="verify" v-model='userOTP' type="number" :length="otpLength">
                                    </v-otp-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 p-0 m-0">
                            <div class="text-center d-block">
                                <p class="m-0">{{$t('anonymousUserVerification.dialogs.alertText')}} {{selectedTime}}
                                </p>
                                <div style="min-height:50px">
                                    <button class="btn btn-link" id="btnVerify" @click="resend" v-if="showResendButton">
                                        <span class="button__buttonText">
                                            {{$t('anonymousUserVerification.dialogs.resend')}}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="d-flex justify-content-end pt-5">
                        <button class="button button--text text-danger" id="btnClose" @click="close">
                            <span class="button__buttonText">
                                {{$t('anonymousUserVerification.dialogs.back')}}
                            </span>
                        </button>
                        <button class="button btn btn-primary text-white"
                            :disabled="userOTP.length < 4 ||showVerfyButton" id="btnVerify" @click="verify">
                            <span class="button__buttonText">
                                {{$t('anonymousUserVerification.dialogs.verify')}}
                            </span>
                        </button>

                    </div>
                </div>


            </div>
        </v-card>
    </v-dialog>
</div>